import { Box } from '@customerio/pluma-components/react';

/** Entry step (email + Google signup). Placeholder — content lands with the entry step PR. */
export function IndexStep() {
  return <Box data-testid="signup-step-index" />;
}
